import { ResponseShareFolderWithGroup } from '@/modules/drive/domain/models/AddGroupFolder'

import { axios, Response } from '../index'

const shareFolderGroup = (
  folderId: string,
  accessProfileId: number,
  permission: 'EDIT' | 'VISUALIZATION'
): Response<ResponseShareFolderWithGroup> => {
  const body = {
    permissionInsideFolder: permission,
    accessProfileId: accessProfileId
  }

  return axios.post(`/v1/folders/${folderId}`, body)
}

export default shareFolderGroup
